// src/utils/fingerprint.js
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export async function getFingerprint() {
  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId; // Unique fingerprint hash
  } catch (error) {
    console.error("Fingerprint error:", error);
    return null;
  }
}